module.exports = __webpack_public_path__ + "48fb2bed9d54478488d792a40d7b7d98.eot";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/MyriadPro-Bold.eot
// module id = 153
// module chunks = 0